import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { Users, Globe, Award, TrendingUp, Target, Eye, Heart } from 'lucide-react';

const About = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>About AuVSys - Global Technology Services Leader</title>
        <meta name="description" content="Learn about AuVSys, a leading global technology services company providing innovative solutions across industries." />
      </Helmet>
      
      <div className="about-page">
        <section className="hero-section">
          <div className="container">
            <div className="hero-content">
              <h1>About AuVSys</h1>
              <p>Leading the digital transformation revolution with innovative technology solutions that empower businesses worldwide for over 25 years.</p>
            </div>
          </div>
        </section>
        
        <section className="stats-section">
          <div className="container">
            <div className="stats-grid">
              <div className="stat-card">
                <Users className="stat-icon" />
                <h3>100,000+</h3>
                <p>Global Employees</p>
              </div>
              <div className="stat-card">
                <Globe className="stat-icon" />
                <h3>50+</h3>
                <p>Countries Served</p>
              </div>
              <div className="stat-card">
                <Award className="stat-icon" />
                <h3>500+</h3>
                <p>Enterprise Clients</p>
              </div>
              <div className="stat-card">
                <TrendingUp className="stat-icon" />
                <h3>$2.5B+</h3>
                <p>Annual Revenue</p>
              </div>
            </div>
          </div>
        </section>
        
        <section className="about-content">
          <div className="container">
            <div className="content-grid">
              <div className="content-section">
                <Target className="section-icon" />
                <h2>Our Mission</h2>
                <p>To accelerate digital transformation for enterprises worldwide through innovative technology solutions, exceptional service delivery, and strategic partnerships that drive sustainable growth and competitive advantage.</p>
              </div>
              
              <div className="content-section">
                <Eye className="section-icon" />
                <h2>Our Vision</h2>
                <p>To be the world's most trusted technology partner, recognized for our ability to solve complex business challenges through cutting-edge solutions and unwavering commitment to client success.</p>
              </div>
              
              <div className="content-section">
                <Heart className="section-icon" />
                <h2>Our Values</h2>
                <div className="values-list">
                  <div className="value-item">
                    <h4>Innovation</h4>
                    <p>Continuously pushing the boundaries of what's possible through research and creative problem-solving.</p>
                  </div>
                  <div className="value-item">
                    <h4>Excellence</h4>
                    <p>Delivering superior quality in everything we do with attention to detail and commitment to best practices.</p>
                  </div>
                  <div className="value-item">
                    <h4>Integrity</h4>
                    <p>Building trust through transparency, ethical practices, and honest communication.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default About;